<template>
<div class="checkbox">
  <label>
    <input type="checkbox" :checked="checked" @change="change">
    <template v-if="label">
    {{ label }}
    </template>
  </label>
</div>
</template>
<script>
export default {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    label: {type: String},
    checked: {type: Boolean, required: true}
  },
  methods: {
    change (e) {
      this.$emit('change', e.target.checked)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CheckboxInput.vue?fe55b8ae